import React, { Fragment } from "react";
import Header from "../components/Header";
import Leftnav from "../components/Leftnav";
import Appfooter from "../components/Appfooter";
import { useTranslation } from "react-i18next";

const Guidelines = () => {
  const { t } = useTranslation("legal");
  const date = "2025-10-13";

  return (
    <Fragment>
      <Header />
      <Leftnav />
      <div className="main-content right-chat-active">
        <div className="middle-sidebar-bottom">
          <div className="middle-sidebar-left">
            <div className="card w-100 border-0 bg-white shadow-xs p-4 mb-4 rounded-xxl">
              <h2 className="fw-700 mb-3">{t("guidelines.title")}</h2>
              <p className="text-grey-700">{t("common.updated", { date })}</p>

              <h4 className="fw-700 mt-4">{t("guidelines.s1t")}</h4>
              <ul>{t("guidelines.s1l", { returnObjects: true }).map((x, i) => <li key={i}>{x}</li>)}</ul>

              <h4 className="fw-700 mt-4">{t("guidelines.s2t")}</h4>
              <ul>{t("guidelines.s2l", { returnObjects: true }).map((x, i) => <li key={i}>{x}</li>)}</ul>

              <h4 className="fw-700 mt-4">{t("guidelines.s3t")}</h4>
              <p>{t("guidelines.s3d")}</p>

              <h4 className="fw-700 mt-4">{t("guidelines.s4t")}</h4>
              <p>{t("guidelines.s4d")}</p>

              <h4 className="fw-700 mt-4">{t("guidelines.s5t")}</h4>
              <p>{t("guidelines.s5d")}</p>

              <h4 className="fw-700 mt-4">{t("guidelines.s6t")}</h4>
              <p>{t("guidelines.s6d", { email: t("common.email") })}</p>
            </div>
          </div>
        </div>
      </div>
      <Appfooter />
    </Fragment>
  );
};

export default Guidelines;
